// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Data from "common/src/data/Data.bs.js";
import * as Route from "../Route.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as Router from "common/src/Router.bs.js";
import * as LbUtils from "./LbUtils.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as LbTopRow from "./LbTopRow.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as LbPlayerName from "./LbPlayerName.bs.js";
import * as LbTypeSelect from "./LbTypeSelect.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as LbPlayerSearch from "./LbPlayerSearch.bs.js";

var topTiers = [
  "CHALLENGER",
  "GRANDMASTER",
  "MASTER"
];

var cols = [
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Rank");
        }), undefined, (function (v, param, param$1) {
          return String(v.num + 1 | 0);
        }), undefined, undefined, undefined, undefined, undefined, 70, undefined, undefined),
  StatsTable2.col(undefined, undefined, (function (param, param$1) {
          return param$1.t("Name");
        }), "pl-[50px]", (function (v, param, param$1) {
          return React.createElement(LbPlayerName.make, {
                      region: Region.fromApiName(v.region),
                      playerName: v.playerName,
                      companionId: Belt_Option.getWithDefault(v.companionId, "5897ad9f-4665-4372-8f3e-6c878adb8918")
                    });
        }), "flex items-center overflow-hidden", undefined, undefined, undefined, undefined, 224, (function (v) {
          return Route.toString({
                      TAG: /* Player */2,
                      _0: {
                        region: Region.fromApiName(v.region),
                        playerName: v.playerName,
                        tag: v.tag,
                        match: undefined
                      }
                    });
        }), undefined),
  StatsTable2.col(undefined, undefined, (function (param, param$1) {
          return param$1.t("LP");
        }), "pl-[52px]", (function (v, param, param$1) {
          var set = param$1.set;
          var match = v.rank;
          var match$1 = v.prePatchRank;
          var delta = match !== undefined && match$1 !== undefined ? (LpChartUtils.divisionToBase(match[0], set) + match[1] | 0) - (LpChartUtils.divisionToBase(match$1[0], set) + match$1[1] | 0) | 0 : undefined;
          var match$2 = v.rank;
          var tmp;
          if (match$2 !== undefined) {
            var split = match$2[0].split(" ");
            var tier = Belt_Array.getExn(split, 0);
            var rank = Belt_Array.getExn(split, 1);
            tmp = React.createElement(React.Fragment, undefined, React.createElement("img", {
                      className: "my-[-2px]",
                      height: "30",
                      src: "https://ap.tft.tools/img/banner/" + tier.toLowerCase() + "_solo.png?width=30",
                      width: "30"
                    }), React.createElement("div", {
                      className: "min-w-[48px] text-center pl-[6px]"
                    }, String(match$2[1]) + "LP"), topTiers.includes(tier) ? null : React.createElement("div", {
                        className: "absolute left-2 top-1 text-sm font-montserrat font-semibold w-4 text-center text-white1 text-shadow"
                      }, rank));
          } else {
            tmp = React.createElement("div", {
                  className: "mx-auto"
                }, "-");
          }
          return React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "lb-ps w-full text-center"
                        }, Belt_Option.mapWithDefault(delta, "-", (function (delta) {
                                return (
                                        delta > 0 ? "+" : ""
                                      ) + String(delta);
                              }))), React.createElement("div", {
                          className: "lb-ss flex items-center relative"
                        }, tmp));
        }), "flex-col justify-center", undefined, undefined, undefined, undefined, 131, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Games");
        }), undefined, (function (v, param, param$1) {
          return React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "lb-ps"
                        }, String(v.patchGames)), React.createElement("div", {
                          className: "lb-ss"
                        }, String(v.games)));
        }), undefined, undefined, undefined, undefined, undefined, 90, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4");
        }), undefined, (function (v, param, param$1) {
          return React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "lb-ps"
                        }, Global.formatPct(undefined, Global.f(v.patchTop4) / Global.f(v.patchGames > 1 ? v.patchGames : 1)) + "%"), React.createElement("div", {
                          className: "lb-ss"
                        }, Global.formatPct(undefined, Global.f(v.top4) / Global.f(v.games > 1 ? v.games : 1)) + "%"));
        }), undefined, undefined, undefined, undefined, undefined, 87, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win");
        }), undefined, (function (v, param, param$1) {
          return React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "lb-ps"
                        }, Global.formatPct(undefined, Global.f(v.patchWon) / Global.f(v.patchGames > 1 ? v.patchGames : 1)) + "%"), React.createElement("div", {
                          className: "lb-ss"
                        }, Global.formatPct(undefined, Global.f(v.won) / Global.f(v.games > 1 ? v.games : 1)) + "%"));
        }), undefined, undefined, undefined, undefined, undefined, 87, undefined, undefined),
  StatsTable2.col(undefined, undefined, (function (param, param$1) {
          return param$1.t("Top Carries");
        }), "justify-center", (function (v, param, param$1) {
          return React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "flex lb-ps gap-[5px]"
                        }, Belt_Array.mapWithIndex(v.patchMostPlayedUnits, (function (idx, unitId) {
                                var unitId$1 = Data.fixId(unitId);
                                return React.createElement(UnitTooltip.make, {
                                            unit: unitId$1,
                                            children: React.createElement(UnitImage.make, {
                                                  unitId: unitId$1,
                                                  size: 30
                                                }),
                                            key: String(idx)
                                          });
                              }))), React.createElement("div", {
                          className: "flex lb-ss gap-[5px]"
                        }, Belt_Array.mapWithIndex(v.mostPlayedUnits, (function (idx, unitId) {
                                var unitId$1 = Data.fixId(unitId);
                                return React.createElement(UnitTooltip.make, {
                                            unit: unitId$1,
                                            children: React.createElement(UnitImage.make, {
                                                  unitId: unitId$1,
                                                  size: 30
                                                }),
                                            key: String(idx)
                                          });
                              }))));
        }), undefined, undefined, undefined, undefined, undefined, 202, undefined, undefined)
];

function LbRanked(Props) {
  var region = Props.region;
  var data = Props.data;
  var router = Router.use(undefined);
  var region$1 = Belt_Option.flatMap(region, Region.fromName);
  Belt_Option.mapWithDefault(region$1, "global", Region.toApiName);
  var lu = data.date;
  var cutoffs = data.thresholds;
  var data$1 = data.entries;
  var lastUpdated = React.useMemo((function () {
          return new Date(lu);
        }), [lu]);
  var match = React.useState(function () {
        return false;
      });
  var usePatchStats = match[0];
  var renderElements = LbUtils.useRenderElements(undefined);
  var data$2 = React.useMemo((function () {
          return Belt_Array.slice(data$1, 0, renderElements);
        }), [
        data$1,
        renderElements
      ]);
  var regionLabel = region$1 !== undefined ? Region.toName3(region$1) : "global";
  var keyFn = React.useCallback((function (d) {
          return d.region + " " + d.playerName + " " + d.tag;
        }), []);
  var setRegion = React.useCallback((function (region) {
          return router.push(Route.toString({
                          TAG: /* Leaderboards */7,
                          _0: {
                            TAG: /* Ranked */0,
                            _0: region
                          }
                        }), undefined, undefined);
        }), []);
  var tmp = {
    region: region$1,
    lastUpdated: lastUpdated,
    setRegion: setRegion
  };
  var tmp$1 = (cutoffs == null) ? undefined : Caml_option.some(cutoffs);
  if (tmp$1 !== undefined) {
    tmp.cutoffs = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(LbPlayerSearch.make, {}), React.createElement(LbTypeSelect.make, {
                  region: region$1,
                  typ: /* Ranked */0
                }), React.createElement(ContentSection.make, {
                  className: "font-montserrat font-medium md:w-[920px]",
                  children: null,
                  noPadding: true
                }, React.createElement(LbTopRow.make, tmp), React.createElement("div", {
                      className: usePatchStats ? "lb-patch-stats" : "lb-season-stats"
                    }, React.createElement(StatsTable2.make, {
                          montserratHeader: true,
                          size: "lg",
                          cols: cols,
                          data: data$2,
                          context: undefined,
                          extraStickyHeader: React.createElement("div", {
                                className: "h-10 flex items-center justify-between pt-1 pr-6 text-center font-semibold"
                              }, React.createElement("div", {
                                    className: "pl-3 font-medium"
                                  }, "Top " + regionLabel + " ranked players"), React.createElement(LbUtils.PatchStatsToggle.make, {
                                    usePatchStats: usePatchStats,
                                    setUsePatchStats: match[1]
                                  })),
                          keyFn: keyFn,
                          stickyColCount: 2,
                          top: "t48"
                        }))));
}

var make = LbRanked;

export {
  topTiers ,
  cols ,
  make ,
  
}
/* cols Not a pure module */
